module.exports = __webpack_public_path__ + "img/main-logo.00fef142.png";